exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer {\n  font-family: \"Source Sans Pro\", \"Helvetica Neue\", \"Helvetica\";\n  text-align: center;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/sass-loader/lib/loader.js!./src/js/components/Disclaimer/disclaimer.scss
// module id = 261
// module chunks = 0